/**
 * @generated SignedSource<<06a53ab93a09b8438003d61b664339b2>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type aiStudioDialogModelByCodeQuery$variables = {
  productCode: string;
  salesChannelId: string;
};
export type aiStudioDialogModelByCodeQuery$data = {
  readonly modelIDByCode: string;
};
export type aiStudioDialogModelByCodeQuery = {
  response: aiStudioDialogModelByCodeQuery$data;
  variables: aiStudioDialogModelByCodeQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "productCode"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "salesChannelId"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "code",
        "variableName": "productCode"
      },
      {
        "kind": "Variable",
        "name": "salesChannelId",
        "variableName": "salesChannelId"
      }
    ],
    "kind": "ScalarField",
    "name": "modelIDByCode",
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "aiStudioDialogModelByCodeQuery",
    "selections": (v1/*:: as any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "aiStudioDialogModelByCodeQuery",
    "selections": (v1/*:: as any*/)
  },
  "params": {
    "cacheID": "4cc5b8edaa69dcc4a61bdc9a13596766",
    "id": null,
    "metadata": {},
    "name": "aiStudioDialogModelByCodeQuery",
    "operationKind": "query",
    "text": "query aiStudioDialogModelByCodeQuery(\n  $productCode: String!\n  $salesChannelId: String!\n) {\n  modelIDByCode(code: $productCode, salesChannelId: $salesChannelId)\n}\n"
  }
};
})();

(node as any).hash = "78aa03ec65f8488d41e0bd296b751e7d";

export default node;
